<template>
  <div id="app">
    <link href="//unpkg.com/layui@2.11.5/dist/css/layui.css" rel="stylesheet">
    <meta name="description"
      content=''>
    <meta name="viewport" content="width=device-width,initial-scale=1,user-scalable=no">

    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
    <Head-view></Head-view>
 
    <router-view></router-view>
    <Bottom-view></Bottom-view>
  </div>
</template>
<script src="//unpkg.com/layui@2.11.5/dist/layui.js"></script>
<script>
import 'swiper/css/swiper.css';
import HeadView from "./components/base/HeadView.vue";
import BottomView from "./components/base/BottomView.vue";
export default {
  data: function () {
    return {

    }
  },

  components: {
    BottomView,
    HeadView,

  }
}
</script>


